export default __webpack_public_path__ + "static/media/icon-benefits.395e6d76.svg";